import { render, staticRenderFns } from "./InventoryInfo.vue?vue&type=template&id=1d1aa77e&scoped=true&"
import script from "./InventoryInfo.vue?vue&type=script&lang=js&"
export * from "./InventoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./InventoryInfo.vue?vue&type=style&index=0&id=1d1aa77e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1aa77e",
  null
  
)

export default component.exports